<template>
  <div class=" widget-calendar">
    <card header-classes="bg-transparent">
      <template v-slot:header>
        <h5 class="h3 mb-0">Database Connection Usage</h5>
      </template>
      <div class=" ">
        <canvas :height="247" :id="doughnetChartID"></canvas>
      </div>
    </card>
  </div>
</template>
<script>
import Chart from "chart.js";
let chart;
export default {
  name: "jdbcDetail",
  components: {
  },
  data() {
    return {
      jdbcMin: {},
      jdbcMax: {},
      jdbcIdle: {},
      jdbcActive: {},
      doughnetChartID: "ordersChart",
    };
  },
  methods: {
    createDoughnetChart() {
      const ctx = document.getElementById(this.doughnetChartID).getContext("2d");
      if (this.doughnetChart) {
        this.doughnetChart.destroy();
      }
      this.doughnetChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Idle", "Active"],
          datasets: [
            {
              label: "Dataset 1",
              tension: 0.4,
              data: [this.jdbcIdle.value, this.jdbcActive.value],
              backgroundColor: [
                "#f5365c",
                "#11cdef",
                "#2dce89",
                "#5e72e4",
                "#11cdef",
              ],
              showLine: false,
              barPercentage: 1.6,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 60,
          rotation: Math.PI,
          circumference: 2 * Math.PI,
          legend: {
            display: true,
            position: "bottom",
            labels: {
              boxWidth: 20,
              font: { size: 14, weight: "bold" },
            },
          },
          tooltips: {
            enabled: true,
            mode: "index",
            intersect: false,
          },
          scales: {
            display: false,
            yAxes: [
              {
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  display: false,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  drawBorder: false,
                  color: "transparent",
                  zeroLineColor: "transparent",
                },
                ticks: {
                  display: false,
                },
              },
            ],
          },
          pluginLabels: {
            jdbcMax: this.jdbcMax.value,
            jdbcMin: this.jdbcMin.value,
          },
          layout: {
            padding: 0,
          },
        },
        plugins: [
          {
            afterDraw: function (chart) {
              const { ctx, width, height } = chart;
              const pluginLabels = chart.options.pluginLabels;
              const jdbcMax = pluginLabels.jdbcMax || "N/A";
              const jdbcMin = pluginLabels.jdbcMin || "N/A";
              const centerText = `${jdbcMax}(max) / ${jdbcMin}(min)`;
              ctx.font = "bold 13px Open Sans";
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";
              ctx.fillStyle = "#8898aa";
              const centerX = width / 1.9;
              const centerY = height / 2.4;
              ctx.fillText(centerText, centerX, centerY);
            },
          },
          {
            id: "sectionLabels",
            afterDraw: (chart) => {
              const { ctx } = chart;
              const meta = chart.getDatasetMeta(0);
              ctx.font = "bold 14px sans-serif";
              ctx.textBaseline = "middle";
              ctx.textAlign = "center";
              ctx.fillStyle = "#ffffff";
              meta.data.forEach((element, index) => {
                const value = chart.data.datasets[0].data[index];
                if (value > 1) {
                  const model = element.tooltipPosition();
                  ctx.fillText(`${value}`, model.x, model.y);
                }
              });
            },
          },
        ],
      });
    },
    formatName(input) {
      return input
        .split('_')
        .map(word =>
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ');
    },
    getJdbcActive(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.jdbcActive.value = response.server.data[0].value;
          this.createDoughnetChart();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getJdbcIdle(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.jdbcIdle.value = response.server.data[0].value;
          this.createDoughnetChart();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getJdbcMax(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.jdbcMax.value = response.server.data[0].value;
          this.createDoughnetChart();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getJdbcMin(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.jdbcMin.value = response.server.data[0].value;
          this.createDoughnetChart();
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getJdbcActive("DB_CONNECTION_ACTIVE");
    this.getJdbcIdle("DB_CONNECTION_IDLE");
    this.getJdbcMax("DB_CONNECTION_MAX");
    this.getJdbcMin("DB_CONNECTION_MIN");
  }
};
</script>